import { Link, LinkProps } from '@tribeplatform/react-ui-kit/Link'

import { BC } from '../../types/index.js'

export const LinkBlock: BC<LinkProps> = Link
